import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { hasStatisticsConsent, trackPageview } from "../lib/analytics";

/**
 * Fires a GA4 page_view every time the route changes,
 * but only if the user has given statistics consent.
 * Must be rendered inside <BrowserRouter>.
 */
const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        if (!hasStatisticsConsent()) return;
        // Give the page a tick to update document.title
        const t = setTimeout(() => trackPageview(location.pathname), 0);
        return () => clearTimeout(t);
    }, [location.pathname]);

    return null;
};

export default AnalyticsTracker;
